function removeCheckedElements(elements)
{
  Array.from(elements).forEach(function(element) {
    element.classList.remove("checked");
  });
}

function checkPhone(id, index) {
  if (!$("#phone" + index).val()) {
    $(id).show();
    $("#phone" + index).css("border", "1px solid red");
    return false;
  }
  return true;
}

function openPopupDevolution() {
  $('body').modal({
    remote: '/customer/order/devolution/',
    backdrop: 'static',
    keyboard: false
  });
  $('.select').each(function(i, obj) {
    if ($('#phone'+(i+1)).val().length > 0) {
      $(obj).trigger("mouseover");
    }
  });
}

function appendElement(index, id_pickup_address) {
  var html = "<div class='spacer' style='height: 10px'>&nbsp</div>";
  html += "<div class='selectedPlace'><span style='color: #000000;'>Ponto escolhido:</span> ";
  html += "<br><span style='font-weight: bold; color:#000000;'>" + $('#name'+index).text() + "</span>";
  html += "<div style='height: 5px'>&nbsp</div>";
  html += $('#address'+index).text();
  html += "<br>" + $('#district'+index).text();
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<span style='color: #000000'>" + $('#time'+index).text() + "</span>"
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<a href='#' onclick='openPopupDevolution();' style='color: #17B687;'>Editar</a>";
  html += "</div>";
  $('.selectedPlace').remove();
//   $('#selectedPlaceSelected').remove();
  $('.spacer').remove();
//   $('input:radio[value=convenience]').parent().append(html);

  var selectedPlaceSelected = $('#selectedPlaceSelected');
  selectedPlaceSelected.html(html)
  selectedPlaceSelected.css({
    display: "flex",
    justifyContent: "center"
  })
  $('#convenience').addClass("checked");
  $('#collect').removeClass("checked");
  $('#post').removeClass("checked");
//   $('selectedPlace').parent().append(html);
  $('#id_return_point_hidden').text(id_pickup_address);
  $('#return_phone_hidden').text($('#phone' + index).val());
}

function appendElementMobile(index, id_pickup_address) {
  var html = "<div class='spacer' style='height: 10px'>&nbsp</div>";
  html += "<div class='selectedPlace'><span style='color: #000000;'>Ponto escolhido:</span> ";
  html += "<br><span style='font-weight: bold; color:#000000;'>" + $('#name' + index).text() + "</span>";
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<span style='color: #858585;'>" + $('#address' + index).text() + "</span>";
  html += "<br><span style='color: #858585;'>" + $('#district' + index).text() + "</span>";
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<span style='color: #000000'>" + $('#time' + index).text() + "</span>"
  html += "<div style='height: 5px'>&nbsp</div>";
  html += "<a href='#' onclick='showModalMobile(" + index + ",\"" + $('#phone' + index).val() + "\");' style='color: #17B687;'>Editar</a>";
  html += "</div>";
  $('.selectedPlace').remove();
  $('.spacer').remove();
  $('input:radio[value=convenience]').parent().append(html);
  $(document).scrollTop($(".selectedPlace").offset().top);

  $('#id_return_point_hidden').text(id_pickup_address);
  $('#return_phone_hidden').text($('#phone' + index).val());
}

function mtel(v, id){
    $(id).hide();
    $("#phone").css("border", "");
    v=v.replace(/\D/g,"");             //Remove tudo o que não é dígito
    v=v.replace(/^(\d{2})(\d)/g,"($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
    v=v.replace(/(\d)(\d{3})$/,"$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos
    return v;
}

function maskTel(element, id) {
  element.value = mtel(element.value, id);
}

function showConfirm(index, id, button, select) {
  $(id).show();
  $(select).css("background-color","#F0F0F0");
  $(button).hide();
  $('.select').each(function(i, obj) {
    if ((i+1) !== index) {
      $('#phone'+(i+1)).val('');
      $('#button'+(i+1)).hide();
      $('#confirm'+(i+1)).hide();
      $('#select'+(i+1)).css("background-color","#FFFFFF");
    }
  });
}

function selectDevolution(index) {
  if ($('#phone'+index).val().length > 0) {
    $('#confirm'+index).show();
  }
  $('#select'+index).css("background-color","#F0F0F0");
  if (!$('#confirm'+index).is(":visible")) {
    $('#button'+index).show();
  }
  $('#confirm-error'+index).hide();
  $('.select').each(function(i, obj) {
    if ((i+1) !== index && $('#phone'+index).val().length === 0) {
      $(obj).trigger("mouseout");
    }
    if ($('#phone'+(i+1)).val().length > 0) {
      $('#confirm'+(i+1)).show();
      $('#select'+(i+1)).css("background-color","#F0F0F0");
      $('#confirm-error'+(i+1)).hide();
    }
  });
}

function unselectDevolution(event, index) {
  event.stopPropagation(); //cancel bubbling
  var ele = event.target || event.srcElement
  if (ele.id === "select"+index){
    $('#button'+index).hide();
    $('#confirm'+index).hide();
    $('#select'+index).css("background-color","#FFFFFF");
  }
}

function handleDevolutionClick(element) {
  $('.selectedPlacePost').remove();
  $('.selectedPlace').remove();
  // $('.selectedPlaceCollect').remove();
  $('#return_phone_hidden').text("");
  $('#id_return_point_hidden').text("");
  $('.spacer').remove();
  var inCollectId = $('#selectedPlaceCollect')

  if (inCollectId) {
    inCollectId.hide()
  }

  if (element.srcElement.value === 'convenience') {
    $('body').modal('destroy');
    $('body').removeData('dft.modal');
    $('body').modal({
      remote: window.secureUrl + '/customer/order/devolution/',
      doNotClose: true
    });
  }  else if (element.srcElement.value === 'collect') {
    var html = "<div class='spacer' style='height: 10px'>&nbsp</div>";
    // var html = htmlCollect();
    // $('input:radio[value=collect]').parent().append(html);
    inCollectId.show()
  }
}

function showModalMobile(index, phone) {
  $('body').modal('destroy');
  $('body').removeData('dft.modal');
  if (phone === undefined) {
    phone = '';
  }
  remote = window.secureUrl + '/customer/order/devolution/?index=' + encodeURIComponent(index) + '&phone=' + encodeURIComponent(phone);
  $('body').modal({
    className: 'devolutionMobile',
    remote: remote
  });
}

function handleDevolutionClickMobile(element) {
  $('.selectedPlacePost').remove();
  $('.selectedPlace').remove();
  // $('.selectedPlaceCollect').remove();
  var inCollectId = $('#selectedPlaceCollect')

  if (inCollectId) {
    inCollectId.hide()
  }

  if (element.target.value === 'convenience') {
    showModalMobile();
  } else if (element.target.value === 'post') {
    var html = "<div class='spacer' style='height: 10px'>&nbsp</div>";
    html += "<div class='selectedPlacePost'>";
    html += "Não esqueça que o produto deve ser devolvido em sua embalagem original ou embrulhado em papel pardo, acompanhado dos manuais, acessórios e nota fiscal. Realizar postagem em até 48 horas. Ficou com alguma dúvida? O site dos Correios explica tudo <a href=\"https://mais.correios.com.br/app/index.php\" class=\"package-link\" target=\"_blank\">aqui.</a>";
    html += "</div>";
    $('.selectedPlacePost').remove();
    $('.spacer').remove();
    $('input:radio[value=post]').parent().append(html);
  } else if (element.target.value === 'collect') {
    // var html = htmlCollect();
    // $('input:radio[value=collect]').parent().append(html);
    inCollectId.show()
  }
}

function htmlCollect() {
  var html = "<div class='selectedPlaceCollect'>";
  html += "Confira abaixo o prazo médio de coleta por região (Em dias úteis): <br><br>";
  html += "<table class='table-border'>";
  html += "<thead>";
  html += "<tr>";
  html += "<th><strong>Região</strong></th>";
  html += "<th><strong>Capital</strong></th>";
  html += "<th><strong>Interior</strong></th>";
  html += "</tr>";
  html += "</thead>";
  html += "<tbody>";
  html += "<tr>";
  html += "<td>Centro-Oeste</td>";
  html += "<td style='text-align: center;'>5 - 6</td>";
  html += "<td style='text-align: center;'>6 - 7</td>";
  html += "</tr>";
  html += "<tr>";
  html += "<td>Norte</td>";
  html += "<td style='text-align: center;'>9 - 10</td>";
  html += "<td style='text-align: center;'>12 - 13</td>";
  html += "</tr>";
  html += "<tr>";
  html += "<tr>";
  html += "<td>Nordeste</td>";
  html += "<td style='text-align: center;'>8 - 9</td>";
  html += "<td style='text-align: center;'>12 - 13</td>";
  html += "</tr>";
  html += "<tr>";
  html += "<td>Sudeste</td>";
  html += "<td style='text-align: center;'>3 - 4</td>";
  html += "<td style='text-align: center;'>5 - 6</td>";
  html += "</tr>";
  html += "<tr>";
  html += "<td>Sul</td>";
  html += "<td style='text-align: center;'>3 - 4</td>";
  html += "<td style='text-align: center;'>4 - 5</td>";
  html += "</tr>";
  html += "</tbody>";
  html += "</table>";
  html += "</div>";

  return html;
}

function getBankCode(bank) {
  return bank.substring(0, bank.indexOf(" "));
}

function exchangeMessageModal(content, size) {
  $('body').modal('destroy');
  $('body').removeData('dft.modal');
  $('body').modal({'content': content});
};

function exchangeModalJustMessage (title, link) {
  return '<div class="modal-content message-modal-content"> \
            <div class="modal-header"> \
                <div class="row"> \
                    <div class="col-12"> \
                        <button type="button" class="modal-close icon-cross close modal-banner-button" data-dismiss="modal" aria-hidden="true"></button> \
                        <h1> \
                            Atenção \
                        </h1> \
                    </div> \
                </div> \
            </div> \
            <div class="modal-body" style="margin-top: 10px;"> \
                <div class="row"> \
                    <div class="col-12">'
                      +  title +
                    '</div> \
                </div> \
            </div> \
          </div>';
};

function showReplacementMethodOptions(element) {
  var choice = element.value;
  var in_credit = $('#replacement-fieldset-line').attr('data-in-credit');

  $('#account-holder').hide();
  $('#bank-account').hide();
  $('#voucher-description').hide();
  $('#product-options-wrapper').hide();
  $('.exchange_warning').hide();

  if (choice == 'refund' && in_credit === 'N') {
    $('#bank-account').show();
  }

  if (choice == 'refund' && in_credit === 'S') {
    $('#account-holder').show();
  }

  if (choice == 'voucher') {
    $('#voucher-description').show();
  }

  if (choice == 'replace') {
    $('#product-options-wrapper').show();
    $('.exchange_warning').show();
    $('.voucher_warning').hide();
  }

  var voucherLabel = $('.customer-exchange-return-label-voucher');

  if(voucherLabel.length) {
    voucherLabel.hide();
    voucherLabel.get(0).offsetHeight;
    voucherLabel.show();
  }
}


$(document).ready(function () {
    $(document).on(
      "change",
      'input[type="radio"][name="OrderForm[account_holder_is_accountable]"]',
      function () {
          $("#joint_account").hide();
          var choice = this.value;
          if (choice === "yes") {
              $("#joint_account").show();
          } else {
            if($('#submit_exchange_request').hasClass('dafiti-exchange')) {
                exchangeMessageModal(exchangeModalJustMessage('O CPF utilizado para depósito deverá ser o titular da conta'), '320,109');
              } else {
                alert('O CPF utilizado para depósito deverá ser o titular da conta');
              }
          }
      }
    );
    $(document).on(
      "change",
      'input[type="radio"][name="OrderForm[joint_account]"]',
      function () {
          $("#bank-account").hide();
          var choice = this.value;
          if (choice === "yes") {
              $("#bank-account").show();
          } else {
              if($('#submit_exchange_request').hasClass('dafiti-exchange')) {
                exchangeMessageModal(exchangeModalJustMessage('Caso seja conta conjunta, é necessario ser primeiro titular da conta'), '320,109');
              }else {
                alert('Caso seja conta conjunta, é necessario ser primeiro titular da conta');
              }
          }
      }
    );

    $(document).on('click', '[data-submit-exchange-request]', function(event){
        event.preventDefault();

        var reasonTextarea = null;
        if (($("#reason-text-fieldset")).length != 0) {

            var reasonTextarea = $('#OrderForm_reason_text').val();
            if(reasonTextarea == '')
            {

                $('#OrderForm_reason_text').focus();

                if($('.submit_exchange_request').hasClass('dafiti-exchange')) {
                    exchangeMessageModal(exchangeModalJustMessage('Detalhe o motivo da sua troca'), '320,109');
                    return;
                }

                alert('Detalhe o motivo da sua troca');
                return;

            }

        }

        var devolutionMethod = null;
        if (($("#devolution-fieldset-line")).length != 0) {

            devolutionMethod = $('input[name="OrderForm[devolution_method]"]:checked').val();
            if(devolutionMethod == undefined)
            {

                if($(this).hasClass('dafiti-exchange')) {
                    exchangeMessageModal(exchangeModalJustMessage('Escolha um método de devolução.'), '320,109');
                    return;
                }

                alert('Escolha um método de devolução.');
                return;
            }

        }

        var packageOption = 'no';
        var replacementMethods = null;
        var newsku = null;

        var bank = null;
        var agency = null;
        var agencyDigit = null;
        var account = null;
        var accountDigit = null;
        var accountType = null;
        var in_credit = $('#replacement-fieldset-line').attr('data-in-credit');
        var type_refund_input = $('#type_refund');
        var type_refund_value = null;

        if (($("#replacement-fieldset-line")).length != 0) {

            replacementMethods = $('input[name="OrderForm[replacement_methods]"]:checked').val();
            if(replacementMethods == undefined)
            {

                if($(this).hasClass('dafiti-exchange')) {
                    exchangeMessageModal(exchangeModalJustMessage('Escolha uma opção para troca/devolução'), '320,109');
                    return;
                }

                alert('Escolha uma opção para troca/devolução');
                return;
            }

            if(replacementMethods == 'replace')
            {
                newsku = $(".selected").attr("id");
                if(newsku == undefined)
                {

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Escolha um tamanho para troca'), '320,109');
                        return;
                    }

                    alert('Escolha um tamanho para troca');
                    return;
                }
            }

            if (replacementMethods == 'refund') {
              if (type_refund_input) {
                type_refund_value = type_refund_input.val()
              }
            }

            if(replacementMethods == 'refund' && in_credit === 'S')
            {
                bank = $("#OrderForm_bank").val();
                accountable_purchase = $('input[type="radio"][name="OrderForm[account_holder_is_accountable]"]:checked').val();
                joint_account = $('input[type="radio"][name="OrderForm[joint_account]"]:checked').val();

                if (accountable_purchase === undefined || joint_account === undefined) {
                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Somente o titular da conta pode receber a restituição.'), '320,109');
                        return;
                      }

                    alert('Somente o titular da conta pode receber a restituição.');
                    return;
                }

                if (accountable_purchase === 'no') {
                  if($(this).hasClass('dafiti-exchange')) {
                      exchangeMessageModal(exchangeModalJustMessage('Somente o titular da conta pode receber a restituição.'), '320,109');
                      return;
                    }

                  alert('Somente o titular da conta pode receber a restituição.');
                  return;
                }

                if (joint_account === 'no') {
                  if($(this).hasClass('dafiti-exchange')) {
                      exchangeMessageModal(exchangeModalJustMessage('Somente o primeiro titular da conta pode receber a restituição.'), '320,109');
                      return;
                    }

                  alert('Somente o titular da conta pode receber a restituição.');
                  return;
                }

                if (bank == '') {

                    $('#OrderForm_bank').focus();

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Por favor, selecione o banco para prosseguir com a restituição.'), '320,109');
                        return;
                    }

                    alert('Por favor, selecione o banco para prosseguir com a restituição.');
                    return;
                }

                agency = $("#OrderForm_agency").val();
                agencyDigit = $("#OrderForm_agencyDigit").val();
                if (agency == '') {

                    $('#OrderForm_agency').focus();

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Por favor, digite o número da agência.'), '320,109');
                        return;
                    }

                    alert('Por favor, digite o número da agência.');
                    return;
                }

                account = $("#OrderForm_account").val();
                accountDigit = $("#OrderForm_accountDigit").val();
                if (account == '') {

                    $('#OrderForm_account').focus();

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Por favor, digite o número da conta.'), '320,109');
                        return;
                    }

                    alert('Por favor, digite o número da conta.');
                    return;
                }

                accountType = $('input[name="OrderForm[account_type]"]:checked').val();
                if ( (accountType == undefined) && (account != undefined) ) {

                    if($(this).hasClass('dafiti-exchange')) {
                        exchangeMessageModal(exchangeModalJustMessage('Escolha o tipo de conta'), '320,109');
                        return;
                    }


                    alert('Escolha o tipo de conta');
                    return;
                }

                if(bank) {
                  var resultBankvalidator = undefined;

                  if(!(banksArray instanceof Object))
                    banksArray = JSON.parse(banksArray);

                  var bankCode = getBankCode(banksArray[bank]);

                  Moip.BankAccount.validate({
                      bankNumber         : bankCode,
                      agencyNumber       : agency,
                      agencyCheckNumber  : agencyDigit,
                      accountNumber      : account,
                      accountCheckNumber : accountDigit,
                      valid: function() {},
                      invalid: function(data) {
                        var errors = "Conta bancária inválida: \n";
                        for(i in data.errors){
                          errors += data.errors[i].description + ")\n";
                        }
                        alert(errors);
                        resultBankvalidator = errors;
                      }
                    });

                    if(resultBankvalidator != undefined)
                      return;
                }
            }

        }

        var order_id = $('#order_id_hidden').text();
        var item_id = $('#item_id_hidden').text();
        var reason_id = $('#reason_id_hidden').text();
        var total_value = $('#total_value_hidden').text();
        var selectedSku = $('#new_sku').text();

        var id_return_point = $('#id_return_point_hidden').text();
        var return_phone = $('#return_phone_hidden').text();

        if (devolutionMethod === 'convenience') {
          if (id_return_point === '' || return_phone === '') {
            alert('Selecione o ponto de devolução e preencha o telefone');
            return;
          }
        }

        $(".button").prop('disabled',true);
        $(".button").css('color', '#AFAFAF');
        $('.loadingRequest').toggle();

        $.ajax({
            url:'/customer/order/ExchangeReturnFinish/',
            data:{
                'order_id':order_id,
                'item_id':item_id,
                'reason_id':reason_id,
                'totalValue':total_value,
                'reasonTextarea':reasonTextarea,
                'devolutionMethod':devolutionMethod,
                'packageOption':packageOption,
                'replacementMethods':replacementMethods,
                'type_refund': type_refund_value,
                'bank':bank,
                'agency':agency,
                'agencyDigit':agencyDigit,
                'account':account,
                'accountDigit':accountDigit,
                'accountType':accountType,
                'selectedSku':selectedSku,
                'id_return_point': id_return_point,
                'return_phone': return_phone
            },
            success: function(data){
                var newUrl = '/customer/order/exchangereturnsuccess/';
                $(location).attr('href',newUrl);
            },
            error: function(data){
                var newUrl = '/customer/order/exchangereturnfailure/';
                $(location).attr('href',newUrl);
            }
        });

    });

});

var newPoints = [];
var ufs = ['AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT','PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO',]

function filter() {
  var uf = document.getElementById("selectUf").value;
  var city = document.getElementById("devolutionCity").value;

  var points = [];

  if (uf) {
    points = filterByUf(uf);
  }

  if (city && city.length >= 3) {
    var pointsSearch = uf ? points : easyPoints;
    points = filterByCity(city, pointsSearch);
  }

  if (!uf && !city) {
    points = easyPoints;
  }

  showPoints(points);
}

function filterByCity(city, points) {
  var pointsFilted = [];
  points.forEach(function(point, index) {
    var cityEasyPointParse = clearText(point.CITY);
    var cityParse = clearText(city);
    var check = cityEasyPointParse.indexOf(cityParse);

    if (check >= 0) {
      pointsFilted.push(point);
    }
  })
  return pointsFilted;
}

function filterByUf(uf) {
  var points = [];

  easyPoints.forEach(function(point, index) {
    if (point.UF == uf) {
      points.push(point);
    }
  })
  return points;
}

function mountSelectUF() {
  var nodeUf = document.getElementById("selectUf");
  var htmlSelectUf = '<option value="">-- Selecione um estado --</option>';
  for (var index = 0; index < ufs.length; index++) {
    htmlSelectUf += '<option value="'+ufs[index]+'">'+ufs[index]+'</option>';
  }
  nodeUf.innerHTML = htmlSelectUf;
}

function showPoints(points) {
  var node = document.getElementById("col");
  var html = "";
  var count = 0;

  if (points) {
    points.forEach(function(point, index){
      html += mountHtmlPoint(point, index);
    });
  }
  node.innerHTML = html;
}

function mountHtmlPoint(point, index) {
  var html = "";
  html += '<div id="select' + (index+1) + '" class="select" style="padding: 10px 10px 10px 10px; overflow: auto;" onmouseover="selectDevolution(' + (index+1) + ');" onmouseout="unselectDevolution(event, ' + (index + 1) + ');">';
  html += '<span id="name' + (index + 1) + '">' + point.NAME + '</span>';
  html += '<div style="height: 5px;">&nbsp;</div>';
  html += '<span id="address' + (index + 1) + '" style="color: #858585;">' + point.ADDRESS + ', ' + point.NUMBER + '</span>';
  html += '<br><span id="district' + (index + 1) + '" style="color: #858585;">' + point.DISTRICT + ' - ' + point.CITY + ' - ' + point.UF + '</span>';
  html += '<div style="height: 5px;">&nbsp;</div>';
  html += '<div>';
  html += '  <div style="float: left; padding: 0 0 10px 0">';
  html += '    <span id="time' + (index + 1) + '">' + point.TIMEAVAILABLE + '</span>';
  html += '    </div>';
  html += '    <div style="text-align: right;">&nbsp;';
  html += '      <button id="button' + (index + 1) + '" style="display: none;" type="button" class="dft button primary" onclick="showConfirm(' + (index+1) + ',\'#confirm' + (index + 1) + '\', \'#button' + (index + 1) + '\', \'#select' + (index + 1) + '\');">Selecione</button>';
  html += '    </div>';
  html += '</div>'
  html += '<div id="confirm' + (index + 1) + '" style="display: none">';
  html += '  <hr style="width: 100%; height: 1px; border: 0; border-top: 1px dotted #DDDDDD; padding: 0; margin: 0;">';
  html += '  <div style="height: 5px;">&nbsp;</div>';
  html += '      <div>';
  html += '    Telefone celular*';
  html += '  </div>';
  html += '  <div>';
  html += '    <div style="float:left;"><input id="phone' + (index + 1) + '" type="text" placeholder="(00) 00000-0000" class="form__input" style="margin: 10px 0 10px 0;" maxlength="15" onkeypress="maskTel(this, \'#confirm-error' + (index + 1) + '\');"></input></div>';
  html += '    <div style="text-align: right;"><button id="confirm' + (index + 1) + '" class="dft button primary" onclick="if (checkPhone(\'#confirm-error' + (index + 1) + '\', ' + (index + 1) + ')) { $(\'body\').modal(\'close\'); appendElement(' + (index + 1) + ',' + point.ID_PICKUP_ADDRESS + ');}">Confirmar</button></div>';
  html += '  </div>'
  html += '</div>'
  html += '  <div id="confirm-error' + (index + 1) + '" style="display:none; clear: left; text-align: left; float:left; color:#FF0000; background-color: #F0F0F0;">Preencha o campo</div>';
  html += '</div>'
  html += '<hr style="width: 100%; height: 1px; border: 0; border-top: 1px solid #DDDDDD; margin: 0;">';

  return html;
}

function clearText(string) {
  return (string.normalize('NFD').replace(/[\u0300-\u036f]/g, "")).toUpperCase();
}

function clearFilter() {
  showPoints(easyPoints);
}
